export const RUNBOOK_PRESETS = [
  { id: 'investigation_started', label: 'Mulai investigasi', actionType: 'investigation_started' },
  { id: 'check_uplink', label: 'Cek router uplink', actionType: 'manual_note' },
  { id: 'backup_verified', label: 'Verifikasi backup path', actionType: 'backup_verified' },
  { id: 'check_olt_odp', label: 'Cek OLT/ODP terkait', actionType: 'manual_note' },
  { id: 'contact_site_customer', label: 'Kontak site/customer', actionType: 'manual_note' },
  { id: 'mitigation_started', label: 'Mulai mitigasi', actionType: 'mitigation_started' },
  { id: 'mitigation_completed', label: 'Mitigasi selesai', actionType: 'mitigation_completed' },
  { id: 'manual_note', label: 'Catatan manual', actionType: 'manual_note' },
];

const RUNBOOK_TICKET_MIRROR_PRESETS = new Set([
  'investigation_started',
  'backup_verified',
  'mitigation_started',
  'mitigation_completed',
  'manual_note',
]);

export const TICKET_SHORTCUTS = [
  { id: 'start_investigating', label: 'Start Investigating', status: 'investigating', actionType: 'investigation_started' },
  { id: 'mark_mitigated', label: 'Mark Mitigated', status: 'mitigated', actionType: 'mitigation_completed' },
  { id: 'close_ticket', label: 'Close Ticket', status: 'closed', actionType: 'mitigation_completed' },
];

export const buildRunbookMessage = ({ presetId, contextLabel }) => {
  const scope = String(contextLabel || '').trim() ? ` (${contextLabel})` : '';
  switch (String(presetId || '').trim().toLowerCase()) {
    case 'investigation_started':
      return `Investigasi dimulai${scope}.`;
    case 'check_uplink':
      return `Pengecekan router uplink dilakukan${scope}.`;
    case 'backup_verified':
      return `Jalur backup diverifikasi${scope}.`;
    case 'check_olt_odp':
      return `ODP/OLT terkait dicek${scope}.`;
    case 'contact_site_customer':
      return `Kontak site/customer dilakukan${scope}.`;
    case 'mitigation_started':
      return `Mitigasi dimulai${scope}.`;
    case 'mitigation_completed':
      return `Mitigasi dinyatakan selesai${scope}.`;
    default:
      return `Catatan operasional ditambahkan${scope}.`;
  }
};

export const buildTicketShortcutNote = (shortcutLabel, contextLabel = '') => {
  const scope = String(contextLabel || '').trim();
  return scope ? `[Shortcut] ${shortcutLabel} (${scope})` : `[Shortcut] ${shortcutLabel}`;
};

export const shouldMirrorRunbookToTicket = ({ presetId, actionType }) => {
  const presetToken = String(presetId || '').trim().toLowerCase();
  if (RUNBOOK_TICKET_MIRROR_PRESETS.has(presetToken)) return true;
  const actionToken = String(actionType || '').trim().toLowerCase();
  return actionToken === 'investigation_started' || actionToken === 'mitigation_started' || actionToken === 'mitigation_completed';
};

export const shouldSkipRunbookDuplicate = ({
  logs = [],
  actionType = '',
  message = '',
  withinMs = 90000,
}) => {
  const latest = Array.isArray(logs) ? logs[0] : null;
  if (!latest) return false;
  const latestAction = String(latest.actionType || latest.action_type || '').trim().toLowerCase();
  const latestMessage = String(latest.message || '').trim().toLowerCase();
  const currentAction = String(actionType || '').trim().toLowerCase();
  const currentMessage = String(message || '').trim().toLowerCase();
  if (!latestAction || !latestMessage || !currentAction || !currentMessage) return false;
  if (latestAction !== currentAction || latestMessage !== currentMessage) return false;
  const latestTime = new Date(latest.createdAt || latest.created_at || '').getTime();
  if (!Number.isFinite(latestTime)) return false;
  return (Date.now() - latestTime) <= Number(withinMs || 0);
};
